export default __webpack_public_path__ + "static/media/ma.c17c6f13.jpg";